module.exports = __webpack_public_path__ + "static/media/slack_step.2ea1972e.svg";